import {Serializable} from "./serializable";

export interface AutomationInt {
  id: string;
  user_id: string;
  uuid: string;
  avatar: string;
  user_email: string;
  user_name: string;
  user_surname: string;
  automation_name: string;
  latitude: string;
  longitude: string;
  support_email: string;
  support_name: string;
  support_phone: string;
  mac_address: string;
  total_licenses: string;
  used_invitation: string;
  users_invited_list: any;
  automation_firmware: string;
  created_at: string;
}

export class Automation implements Serializable<Automation> {

  id: string;
  info: {
    geofence_active: boolean,
    geofence_range: string,
    latitude: string,
    longitude: string,
    name: string,
    support_email: string,
    support_name: string,
    support_phone: string
  };
  user: {
    avatar: {url: string},
    url: string,
    email: string,
    id: string,
    name: string,
    surname: string
  };
  user_id: string;
  uuid: string;
  mac: string;
  total_licenses: string;
  used_invitation: string;
  users_invited_list: any;
  automation_firmware: string;
  created_at: string;

  deserialize(input: any): Automation {
    if (!input) return null;
    this.id = input.id;
    this.info = input.info;
    this.user = input.user;
    this.user_id = input.user_id;
    this.uuid = input.uuid;
    this.mac = input.mac;
    this.total_licenses = input.total_licenses;
    this.used_invitation = input.used_invitation;
    this.users_invited_list = input.users_invited_list;
    this.created_at = input.created_at;
    return this;
  }

  flatten(): AutomationInt {
    return {
      id: this.id,
      user_id: this.user_id,
      uuid: this.uuid,
      avatar: this.user.avatar.url,
      user_email: this.user.email,
      user_name: this.user.name,
      user_surname: this.user.surname,
      automation_name: this.info.name,
      latitude: this.info.latitude,
      longitude: this.info.longitude,
      support_email: this.info.support_email,
      support_name: this.info.support_name,
      support_phone: this.info.support_phone,
      mac_address: this.mac,
      total_licenses: this.total_licenses,
      used_invitation: this.used_invitation,
      users_invited_list: this.users_invited_list,
      automation_firmware: this.automation_firmware,
      created_at: this.created_at
    };
  }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/models/automation.ts